import React from "react";
import { TextField } from "@material-ui/core";
import { RoundedButton } from "@packages/ui";

const RentalManageBookingForm = ({
  minDate,
  maxDate,
  loading,
  onSubmit,
  errors,
  register,
  setValue,
}) => (
  <>
    <form onSubmit={onSubmit}>
      <TextField
        {...register("newReturnDate", {
          required: "New Return Date is required",
          validate: (value) => {
            if (!value) {
              return "New Return Date is required";
            }
            if (value < minDate) {
              return `Date cannot be earlier than ${minDate}`;
            }
            if (value > maxDate) {
              return `Date cannot be later than ${maxDate}`;
            }
            return true;
          },
        })}
        name="newReturnDate"
        label="New Return Date"
        variant="outlined"
        fullWidth
        type="date"
        margin="0 auto"
        InputLabelProps={{ shrink: true }}
        inputProps={{ min: minDate, max: maxDate }}
        onChange={(e) => setValue("newReturnDate", e.target.value, { shouldValidate: true })}
        error={!!errors.newReturnDate}
        helperText={errors.newReturnDate?.message}
        style={{ marginBottom: "10px", marginTop: "5px" }}
      />
      <RoundedButton
        variant="contained"
        fullWidth
        type="submit"
        loading={loading}
        sx={{ textTransform: "none" }}
      >
        Submit
      </RoundedButton>
    </form>
  </>
);

export default RentalManageBookingForm;
